import React from "react";

const GradientButton = ({ text, onClick, disabled }) => {
  return (
    <button className="gradient-button" onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
};

export default GradientButton;
